
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/baza-wiedzy/[articleCategorySlug]",
      function () {
        return require("private-next-pages/baza-wiedzy/[articleCategorySlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/baza-wiedzy/[articleCategorySlug]"])
      });
    }
  